import { intercepted2ogpsikxxj4u0 as intercepted } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from '../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CancellableContinuationImpl.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PlatformUtils_getInstance3hk77c3xwk5zt as PlatformUtils_getInstance } from '../../../../../../../ktor-ktor-utils/io/ktor/util/PlatformUtils.mjs';
import {
  Companion_instance1co2nkledm2ru as Companion_instance,
  _Result___init__impl__xyqfz810za1hm0unrcw as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { Error3ofk6owajcepa as Error_0 } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { readBodyBrowser2vmfk0na3k29n as readBodyBrowser } from '../browser/BrowserFetch.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *commonFetch(input, init, requestConfig, config, callJob, $completion) {
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  return yield () => {
    var uCont = $completion;
    var cancellable = new (CancellableContinuationImpl())(intercepted(uCont), 1);
    cancellable.z10();
    var continuation = cancellable;
    var controller = AbortController_0();
    init.signal = controller.signal;
    config.w5w_1(init);
    requestConfig(init);
    callJob.gx(true, VOID, (it) => {
      controller.abort();
      return Unit_instance;
    });
    var tmp;
    if (PlatformUtils_getInstance().d4p_1) {
      tmp = fetch(input, init);
    } else {
      var options = Object.assign(Object.create(null), init, config.x5w_1);
      tmp = fetch(input, options);
    }
    var promise = tmp;
    var tmp_0 = (it) => {
      // Inline function 'kotlin.coroutines.resume' call
      var this_0 = continuation;
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$5 = _Result___init__impl__xyqfz8(it);
      this_0.rc(tmp$ret$5);
      return Unit_instance;
    };
    promise.then(tmp_0, (it) => {
      var tmp0 = continuation;
      // Inline function 'kotlin.coroutines.resumeWithException' call
      // Inline function 'kotlin.Companion.failure' call
      var exception = Error_0().ke('Fail to fetch', it);
      var tmp$ret$7 = _Result___init__impl__xyqfz8(createFailure(exception));
      tmp0.rc(tmp$ret$7);
      return Unit_instance;
    });
    return cancellable.jy();
  };
}
function readBody(_this__u8e3s4, response) {
  return readBodyBrowser(_this__u8e3s4, response);
}
function AbortController_0() {
  return new AbortController();
}
//region block: exports
export {
  commonFetch as commonFetch9qseoz65108t,
  readBody as readBody4gczno2wau05,
};
//endregion

//# sourceMappingURL=Utils.mjs.map
